export class ExportedInstanceRecord {
  constructor(private readonly number: string, private readonly url: string, private readonly instanceId: number) {}

  getNumber() {
    return this.number;
  }

  getUrl() {
    return this.url;
  }

  getInstanceId() {
    return this.instanceId;
  }
}
